import { createHandlerChainRunnerOptionalParameter, Handler } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";

export interface CustomShippingSecondParameterValid extends ApiParameter {
    receiverContactPhoneValid?: boolean;
}

export interface CustomShippingSecondModel {
    receiverContactPhoneValid?: boolean;
}

type HandlerType = CustomApiHandler<CustomShippingSecondParameterValid, CustomShippingSecondModel>;

export const DispatShippingReciverContactPhoneValid: HandlerType = (props: any) => {
    props.dispatch({
        type: "ShippingPage/CustomFields/receiverContactPhoneValid",
        result: props.parameter.receiverContactPhoneValid,
    });
};

export const chain = [DispatShippingReciverContactPhoneValid];

const customShippingFieldReceiverPhoneValid = createHandlerChainRunnerOptionalParameter(
    chain,
    {},
    "CustomShippingFieldReceiverPhoneValid",
);
export default customShippingFieldReceiverPhoneValid;
